import {Action} from 'redux';

export const NO_OP = 'NO_OP';
export type noopAction = Action<typeof NO_OP>;

export const INIT = '@@INIT';
export type initAction = Action<typeof INIT>;

export type testActions =
 noopAction 
 | initAction;